(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.sizeGuideInit) return;
  window.sizeGuideInit = true;

  var sizeData = [
    { fr: '34', us: '24', belt: 90 },
    { fr: '35', us: '25', belt: 95 },
    { fr: '36', us: '26', belt: 100 },
    { fr: '38', us: '28', belt: 100 },
    { fr: '40', us: '30', belt: 105 },
    { fr: '42', us: '32', belt: 110 },
    { fr: '44', us: '34', belt: 115 },
    { fr: '46', us: '36', belt: 120 },
    { fr: '48', us: '38', belt: 125 },
    { fr: '50', us: '40', belt: 130 },
    { fr: '52', us: '42', belt: 135 },
    { fr: '54', us: '44', belt: 135 },
    { fr: '56', us: '46', belt: 140 },
    { fr: '58', us: '48', belt: 145 },
    { fr: '60+', us: '48+', belt: 150 }
  ];

  var currentSystem = 'fr';

  function populatePantsSelect() {
    var select = document.getElementById('sg-pants-select');
    if (!select) return;
    var current = select.value;
    select.innerHTML = '';
    sizeData.forEach(function (row) {
      var opt = document.createElement('option');
      opt.value = row[currentSystem];
      opt.textContent = row[currentSystem];
      if (opt.value === current) opt.selected = true;
      select.appendChild(opt);
    });
    updateBeltResult();
  }

  function populateBeltSelect() {
    var select = document.getElementById('sg-belt-select');
    if (!select) return;
    var belts = sizeData.map(function (r) { return r.belt; })
      .filter(function (v, i, a) { return a.indexOf(v) === i; });
    belts.forEach(function (belt) {
      var opt = document.createElement('option');
      opt.value = belt;
      opt.textContent = belt + ' cm';
      select.appendChild(opt);
    });
    updatePantsResult();
  }

  function updateBeltResult() {
    var select = document.getElementById('sg-pants-select');
    var result = document.getElementById('sg-belt-result');
    if (!select || !result) return;
    var row = sizeData.find(function (r) { return r[currentSystem] === select.value; });
    result.textContent = row ? row.belt + ' cm' : '—';
  }

  function updatePantsResult() {
    var select = document.getElementById('sg-belt-select');
    var result = document.getElementById('sg-pants-result');
    if (!select || !result) return;
    var belt = parseInt(select.value);
    var matches = sizeData.filter(function (r) { return r.belt === belt; });
    if (!matches.length) { result.textContent = '—'; return; }
    result.innerHTML = 'FR ' + matches.map(function (r) { return r.fr; }).join(' / ')
      + '<br><span style="font-size:14px;font-weight:400;color:#6B6B6B">US '
      + matches.map(function (r) { return r.us; }).join(' / ') + '</span>';
  }

  function initSizeGuide() {
    var modal = document.getElementById('size-guide-modal');
    if (!modal) return;

    modal.querySelectorAll('.sg-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modal.querySelectorAll('.sg-tab').forEach(function (t) { t.classList.remove('sg-tab--active'); });
        modal.querySelectorAll('.sg-panel').forEach(function (p) { p.classList.remove('sg-panel--active'); });
        tab.classList.add('sg-tab--active');
        modal.querySelector('[data-panel="' + tab.dataset.tab + '"]').classList.add('sg-panel--active');
      });
    });

    modal.querySelectorAll('.sg-toggle-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('.sg-toggle-btn').forEach(function (b) { b.classList.remove('sg-toggle-btn--active'); });
        btn.classList.add('sg-toggle-btn--active');
        currentSystem = btn.dataset.system;
        populatePantsSelect();
      });
    });

    var pantsSelect = document.getElementById('sg-pants-select');
    var beltSelect = document.getElementById('sg-belt-select');
    if (pantsSelect) pantsSelect.addEventListener('change', updateBeltResult);
    if (beltSelect) beltSelect.addEventListener('change', updatePantsResult);

    populatePantsSelect();
    populateBeltSelect();

    modal.addEventListener('close', function () { document.body.style.overflow = ''; });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
